import React, { useEffect, useState } from 'react';
import { Row, Col, Anchor, Modal, Form, notification, Input } from 'antd';
import Errores from './Errores';
import { guardar_mail } from '../../utils/ConexionServidor';
import axios from "axios";

import { useHistory } from "react-router-dom";

import '../../assets/css/publicaciones.css';
import PdfFlipbook from '../flipbook/PdfFlipbook';

const PDF_URL = `${process.env.PUBLIC_URL}/pdfs/canimolt_comprendioestadistico_17-21.pdf`;

const CompendioCompleto = () => {
    console.log('local', localStorage.status)

    const [modal_mail, setModalMail] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [error, seterror] = useState('');
    const history = useHistory();

    const mensaje = (tipo, titulo) => {
        notification[tipo]({
            message: titulo,
            duration: 10,
        });
    }

    const onFinish = async values => {
        values.type = 'Compendio Completo';
        guardar_mail(values).then(({ data, status, success }) => {
            switch (success) {
                case true:
                    localStorage.setItem('email', data.email);
                    localStorage.setItem('status9', success);

                    setModalMail(false);
                    break;
                default:
                    mensaje('error', 'Advertencia');
                    break;
            }
        });

    };

    useEffect(() => {
        if (localStorage.status9 != 'true') {
            setModalMail(true);
        } else {
            setModalMail(false);
        }
        

    });

    useEffect(() => {
        const cleanup = () => {
          // do your cleanup
          localStorage.removeItem('status9');
          localStorage.clear();
        }
        window.addEventListener('beforeunload', cleanup);
        return () => {
            window.removeEventListener('beforeunload', cleanup);
        }
        }, []);
    
    return (
        <Row>
            <Col span={24} id="revista">

                <p className="titulo_revista_reportes">
                    Compendio Estadístico 2017 - 2021

                </p>
            </Col>
            <Col span={20} offset={2}><br />
                <PdfFlipbook url={PDF_URL} width={500} height={700} />
                <br /><br />
            </Col>
            <Modal
                visible={modal_mail}
                onOk={() => setModalMail(false)}
                onCancel={() => setModalMail(false)}
                closable={false}
                title="Para visualizar el documento ingresa un correo"
                footer={null}
                style={{}}
                bodyStyle={{}}>
                <Form className="login-form" onFinish={onFinish} layout="vertical">
                    <Form.Item
                        name="email"
                        label={<span style={{ color: '#000000' }}>Correo electrónico</span>}
                        rules={[
                            {
                                required: true,
                                message: 'Ingresa tu correo!',
                                type: 'email'
                            },
                        ]}
                    >
                        <Input style={{ backgroundColor: '#F5F8F5' }} />
                    </Form.Item>
                    {error ? <Form.Item><Errores mensaje={error} /></Form.Item> : null}
                    <Form.Item>
                        <Row>
                            <Col span={24} style={{ textAlign: 'center' }}>

                                <button htmlType="submit" class="btn-amarillo boton-amarillo">
                                    Entrar
                                </button>

                            </Col>
                        </Row>

                    </Form.Item>
                </Form>
            </Modal>
        </Row>
    );
}

export default CompendioCompleto;
